import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { LucideIcon } from 'lucide-react-native';
import { Pressable } from 'react-native';

/** One side of the chart / table toggle. */
export const ViewSegment = ({
  icon: Icon,
  label,
  selected,
  onPress,
}: {
  icon: LucideIcon;
  label: string;
  selected: boolean;
  onPress: () => void;
}) => {
  const { rpx } = useResponsiveContext();
  return (
    <Pressable
      accessibilityRole="radio"
      accessibilityLabel={label}
      accessibilityState={{ checked: selected }}
      onPress={onPress}
      hitSlop={{ top: 10, bottom: 10, left: 2, right: 2 }}
      style={({ pressed }) => ({
        width: rpx(28),
        height: rpx(24),
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: rpx(6),
        borderWidth: 1,
        borderColor: selected ? aiColors.border : 'transparent',
        backgroundColor: selected ? aiColors.card : 'transparent',
        opacity: pressed ? 0.7 : 1,
      })}
    >
      <Icon
        size={14}
        color={selected ? aiColors.foreground : aiColors.mutedForeground}
      />
    </Pressable>
  );
};
